module.exports = __webpack_public_path__ + "img/evc.d0a43be4.png";